var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 21.5596L13.4453 20.0596",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0254 0.0800781V1.03613H9.86523V0.0800781H14.0254Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79649 17.5596H0.445312L5.72829 2.55957H8.28734L13.5703 17.5596H11.2191L7.06874 5.28418H6.95405L2.79649 17.5596ZM3.19074 11.6855H10.8177V13.5898H3.19074V11.6855Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAMinus);
export default __webpack_public_path__ + "static/media/a-minus.afdd2811816f38f35eaf15de6823eefa.svg";
export { ForwardRef as ReactComponent };